import { render, staticRenderFns } from "./Now.vue?vue&type=template&id=71505247&scoped=true&"
import script from "./Now.vue?vue&type=script&lang=js&"
export * from "./Now.vue?vue&type=script&lang=js&"
import style0 from "./Now.vue?vue&type=style&index=0&id=71505247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71505247",
  null
  
)

export default component.exports